import styled from 'styled-components'
import { Form } from '@sketch/components'

export const StyledForm = styled(Form)`
  margin-top: 24px;
`
